import { Tabs } from "antd";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ListUser from "./user/ListUser/ListUser";
import ListRole from "./role/ListRole/ListRole";
import ActionButtonGradient from "../../components/button/ActionButtonGradient";

const UserManagement = () => {
    const navigate = useNavigate()
    const params = useParams()
    const [activeTab, setActiveTab] = useState('1')

    const handleTabChange = (key) => {
        setActiveTab(key)
        navigate(`/user-management/${key}`)
    }

    useEffect(() => {
        if (params.tab_order) {
            setActiveTab(params.tab_order)
        }
    }, [params.tab_order])

    const items = [
        {
          key: '1',
          label: `User List`,
          children: <ListUser hideCreateButton={true}/>
        },
        {
          key: '2',
          label: `Role List`,
          children: <ListRole hideCreateButton={true}/>
        }
    ]

    const [tabItems, setTabItems] = useState(items)

    return (
        <div className="container-fluid justify-content-center" style={{ 
            maxWidth: '1200px', 
            margin: '0 auto',
            width: '100%',
        }}>
            <div style={{
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                padding: '24px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                border: '1px solid #f0f0f0'
            }}>
                <div className="mb-3" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <h5 style={{ 
                        margin: 0,
                        fontWeight: 600,
                        color: '#1a1a1a',
                        fontSize: '18px'
                    }}>
                        User Management
                    </h5>
                    { activeTab === '1' ? 
                        <ActionButtonGradient
                            onClick={() => navigate('/user-management/user-form')}
                            variant="success"
                            children={"Create User"}
                        />
                        :
                        <ActionButtonGradient
                            onClick={() => navigate('/user-management/role-form')}
                            variant="success"
                            children={"Create Role"}
                        />
                    }
                </div>
                <Tabs
                    activeKey={activeTab}
                    onChange={handleTabChange}
                    items={tabItems}
                />
            </div>
        </div>
    )
}

export default UserManagement